import styled from "@emotion/styled";

export const ChatStyles = styled("div")`
  position: relative;
  height: 100%;
  width: 100%;

  .chat-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    background-color: #fff;
    border: solid 1px #e2e2ed;
    border-radius: 6px;
    margin-left: 20px;
  }

  .chat {
    width: 100%;

    &__empty-message {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0.7;
    }

    &__header {
      width: 100%;
      height: 80px;
      border-bottom: solid 1px #e2e2ed;
      padding-top: 20px;
    }

    &__contact {
      display: flex;
    }

    &__contact-avatar {
      min-width: 40px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: rgb(115, 66, 153);
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      margin-left: 20px;
      overflow: hidden;
    }

    &__contact-avatar-text {
      color: white;
    }

    &__contact-info {
      width: 100%;
      margin-left: 10px;
    }

    &__contact-name {
      display: flex;
      color: #293359;
    }

    &__contact-member {
      position: relative;
      top: 2px;
      left: 8px;
    }

    &__contact-address {
      color: #4a5580;
    }

    /*
        &__contact-menu-wrap {
            position: relative;
            top: -4px;
            left: 0;
            width: 48px;
            height: 48px;
            cursor: pointer;
            margin-right: 15px;
            border-radius: 6px;

            &:hover {
                background-color: #f6f6fa;
            }
        }

        &__contact-menu {
            position: relative;
            top: 0;
            left: 0;
            rotate: 90deg;
            width: 48px;
            height: 48px;
        }
        */
  }
`;

export const DateItem = styled("div")`
  text-align: center;
  padding: 12px;
`;

export const DateItemShadow = styled("span")`
  background: #f6f6fa;
  padding: 4px 14px;
  border-radius: 15px;
  font-weight: 600;
`;
